var $e6aab2ba9f638e4a$exports = {};
$e6aab2ba9f638e4a$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `La date s\xe9lectionn\xe9e est indisponible`,
            other: `Les dates s\xe9lectionn\xe9es sont indisponibles`
        })}.`
};


export {$e6aab2ba9f638e4a$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
